type Group {
  group_id: ID!
  group_name: String
  organisation_id: String
  disabled: Boolean
  accept_reminders: Boolean
  users: [User!]
  user_ids: [String!]
}

input GetGroupInput {
  group_ids: [String!]
  group_names: [String!]
  filter_organisation_id: String
  page_size: Int
  bookmark: String
  show_disabled: Boolean
}

input CreateGroupInput {
  group_name: String
  disabled: Boolean
  accept_reminders: Boolean
}

input UpdateGroupInput {
  disabled: Boolean
  accept_reminders: Boolean
}
